import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl64ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    taxNumber: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    taxDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")).typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    taxYear: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .test(
        "is-valid-tax-year",
        t(
          "Η υποχρέωση υποβολής δεν υφίσταται για τα έτη 2020 και μετά. Επιλέξτε Φορολογικό έτος 2019 ή προγενέστερο."
        ),
        (value) => {
          if (value) {
            const taxYear = parseInt(value, 10);
            return taxYear <= 2019;
          }
          return false;
        }
      ),
  });
};
